import style from "../../Pages/ServicesDisplay.module.css";
import KioskBanking from "../images/ServiceDetailImg/KioskBanking.png";

const BankingKiosk = () => {
  return (
    <article className={style.ServiceDetailArticle}>
      <h1>Banking Kiosk facility, BC enrollment process and benefits</h1>
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <picture>
          <img src={KioskBanking}></img>
        </picture>
      </div>
      <p className={style.Paragraph}>
        <strong>  Rendering Banking Facilities in collaboration with PSU banks, Private
        Banks and Payment Banks to unserved masses through our
        Franchises/Agents.</strong>
        <br/>   <br/>Banking Facilities include Account Opening, Fund
        Transfer/Money Transfer, Withdrawal/Deposit and Facilitator for loan,
        Recovery agent for loan along with all social security schemes.Nabotec
        Solutions Private limited is in constant upgradation process by getting
        in tie-up with all the top PSU banks, private Banks and even the Payment
        Banks for making the Banking facilities most viable in almost complete
        unprivileged and under privileged sectors of our country through its
        centres. Through our centres we provide the complete solutions of
        Banking like Account opening, money Deposit, money withdrawal, Fund
        Transfer, Money Transfer, KYC updation, Lead generation for loan and
        Recovery agent for the NPA account. By Opening the S/B Account/Jan-dhan
        Khata at the rural level and to financially literate to the rural
        masses, Nabotec solutions are empowering the digital India Project in
        the true sense and value. Under Banking our Centres also caters various
        social security schemes initiated by the government to ensure the
        health, life and pension to the citizens of the country through PMJJY,
        PMSBY and APY.
      </p>
    </article>
  );
};

export default BankingKiosk;
